import styled, { css } from 'styled-components'
import { fanta, PrimaryButton, OutlineButton, TextArea } from '@chegg/fanta'
import { ButtonAttributes } from './types'

interface ButtonFileProps {
  fileUpload?: boolean
}

type ButtonProps = ButtonAttributes & ButtonFileProps

interface TermsProps {
  textColor?: string
}

const handlePrimaryButtonColor =
  css <
  ButtonProps >
  `
  background-color: ${({ buttonColor }) => buttonColor || fanta.colors.cheggOrange};
  color: ${({ buttonTextColor }) => buttonTextColor || fanta.colors.white};
  border-color: ${({ buttonColor }) => buttonColor || fanta.colors.cheggOrange};

  &:hover {
    background-color: ${({ buttonHoverColor }) => buttonHoverColor || fanta.colors.orangeDark};
    border-color: ${({ buttonHoverColor }) => buttonHoverColor || fanta.colors.orangeDark};
  }
`

const handleOutlineButtonColor =
  css <
  ButtonProps >
  `
  border-color: ${({ buttonColor }) => buttonColor || fanta.colors.cheggOrange};
  color: ${({ buttonColor }) => buttonColor || fanta.colors.cheggOrange};
  &:hover {
    background-color: ${({ buttonHoverColor }) => buttonHoverColor || fanta.colors.orangeDark};
    border-color: ${({ buttonHoverColor }) => buttonHoverColor || fanta.colors.orangeDark};
    color: ${({ buttonTextColor }) => buttonTextColor || fanta.colors.white};
  }
`

const handleDisabledButtonColor =
  css <
  ButtonProps >
  `
  color: ${({ buttonDisabledTextColor }) => buttonDisabledTextColor || fanta.colors.greyMedium};
  background-color: ${({ buttonDisabledColor }) => buttonDisabledColor || fanta.colors.greyLight};
  border-color: ${({ buttonDisabledColor }) => buttonDisabledColor || fanta.colors.greyLight};

  :hover {
    color: ${({ buttonDisabledTextColor }) => buttonDisabledTextColor || fanta.colors.greyMedium} !important;
    background-color: ${({ buttonDisabledColor }) => buttonDisabledColor || fanta.colors.greyLight};
    border-color: ${({ buttonDisabledColor }) => buttonDisabledColor || fanta.colors.greyLight};
  }
`

export const CheckPaperButton =
  styled(PrimaryButton) <
  ButtonProps >
  `
  width: 100%;
  padding: ${fanta.spacing.xs} 0;

  &:disabled {
    cursor: not-allowed;
    ${handleDisabledButtonColor}

    ${({ disabledOpacity }) =>
      disabledOpacity &&
      css`
        opacity: ${disabledOpacity};
      `}
  }

  ${handlePrimaryButtonColor}

  ${({ borderRadius }) =>
    borderRadius &&
    css`
      border-radius: ${borderRadius};
    `}

  ${({ fontSize }) =>
    fontSize &&
    css`
      font-size: ${fontSize};
    `}
`

export const UploadButton =
  styled(OutlineButton) <
  ButtonProps >
  `
  flex: 1;
  padding: ${fanta.spacing.xs} 0;

  &:first-child {
    margin-right: ${fanta.spacing.sm};
  }

  > svg,
  > span > svg {
    fill: ${({ buttonColor }) => buttonColor || fanta.colors.cheggOrange};

    margin-right: ${fanta.spacing.xs};
  }

  > span {
    height: 23px;
    line-height: 1.25;
  }

  &:disabled {
    > svg,
    > span > svg {
      fill: ${({ buttonDisabledTextColor }) => buttonDisabledTextColor || fanta.colors.greyMedium};
    }
    ${handleDisabledButtonColor}
  }

  &:hover {
    > svg,
    > span > svg {
      fill: ${({ buttonTextColor }) => buttonTextColor || fanta.colors.white};
    }
  }

  ${({ fileUpload }) =>
    fileUpload &&
    css`
      > input[type='file'] {
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        opacity: 0;
        width: 100%;
        height: 100%;
      }

      > input[type='file']:hover {
        cursor: pointer;
      }
    `}

  ${handleOutlineButtonColor}

  ${({ borderRadius }) =>
    borderRadius &&
    css`
      border-radius: ${borderRadius};
    `}
`

export const UploadComputerButton = styled(UploadButton)``
export const UploadGDriveButton = styled(UploadButton)``

export const DocumentTextAreaContainer = styled.div`
  margin-top: 10px;
  background-color: #fff;
  padding: 0;
`

export const PastePaperTextArea = styled(TextArea)`
  resize: none;
  margin-bottom: ${fanta.spacing.xxs};
`

export const TermsConditionsContainer =
  styled.div <
  TermsProps >
  `
  margin-top: -${fanta.spacing.xs};
  > a {
    color: ${({ textColor }) => textColor || fanta.colors.white};
    text-decoration: none;
  }
`

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  padding: ${fanta.spacing.sm} ${fanta.spacing.xs};
  background-color: ${fanta.colors.coralLight};
  margin-bottom: ${fanta.spacing.sm};
`
export const ErrorText = styled.span`
  margin-left: ${fanta.spacing.xxs};
  font-size: ${fanta.font.size.sm};
`

export const ErrorCloseContainer = styled.div`
  margin-left: auto;
  cursor: pointer;
`
